import {
    FETCH_TEMPLATE_CONTENT_REQUEST,
    FETCH_TEMPLATE_CONTENT_SUCCESS,
    FETCH_TEMPLATE_CONTENT_FAILURE,
  } from "./FetchTemplateContentTypes";
  
  const initialState = {
    loading: false,
    templateContent: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TEMPLATE_CONTENT_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_TEMPLATE_CONTENT_SUCCESS:
        return {
          loading: false,
          templateContent: action.payload,
          error: "",
        };
      case FETCH_TEMPLATE_CONTENT_FAILURE:
        return {
          loading: false,
          templateContent: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  